import { useEffect, useState } from "react";

/**
 * Tracks a CSS media query from JS, so a component can branch on the same
 * breakpoint its stylesheet uses. Reads synchronously on first render —
 * starting at `false` would paint the desktop layout on a phone for a
 * frame before correcting itself.
 */
export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
        // Re-read on mount: the query may have changed between the initial
        // state and this effect running.
        setMatches(mql.matches);
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return matches;
};

/**
 * The one breakpoint at which the chat shell stops being three columns.
 * Kept next to the hook so the stylesheets and the components that read
 * it can't drift apart — ChatPage.module.scss and SideBarLeft.module.scss
 * both switch to the overlay layout at this width.
 */
export const MOBILE_QUERY = '(max-width: 768px)';
